// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10vp9","rightAdornment":"Header_rightAdornment__3FQSx"};